module.exports={
    message: {
        header_menu:{
            home: 'HOME',
            brand: 'ABOUT US',
            product: "MODELS",
            shop: "SHOP",
            service: "SERVICES",
            post_bar: "FORUM",
            contact_us: "CONTACT US"
        },
        gywm:{
            company:'Company Profile',
            contactus:'Contact Us',
            joinus:'Join Us'
        },
        bzzx:{
            purchase_guide:'Purchase Guide',
            payment_method:'Payment Method',
            distribution_policy:'Delivery Policy'
        },
        shzc:{
            after_sale_policy:'After-sale Policy'
        },
        footer:{
            about:'About Us',
            help:'Help Center',
            after_sale:'Supports',
            wx:'Wechat',
            wb:'Sina',
            ser_tel:'Hotlines',
            friendLink:"Links",
            links:"Motor fan",
            shop:'Online Shopping Mall',
            mediaCenter:'Media Center',
            wuService:'Promise service',
        },
        home_page:{
            keyword:'Please enter the keyword',
            related_title:'New Products',
            hot_title:'Accessories',
            active_title:'Sales',
            service:{
                service_title:'After-sale Service',
                contact_title:'Contact Us',
            }
        },
        brand_page:{
            culture:'Corporate Culture',
            event:'History',
            future:'Visions',
        },
        service_page:{
            service_introduce:'Service Introduction',
            keep:'Maintenance Plan',
            service_details1:'Compensation for Vehicle Lost',
            service_details2:'Third Party Injury Compensation',
            service_details3:'Compensation for Driver\'s Accidental Injury',
            service_details4:'Service Guarantee Provisions',
            service_details5:'Disclaimers',
        },
        contact_us_page:{
            apply_btn:'Apply for Franchisee',
            all_store:'All Stores',
            name:'Please enter your name',
            tel:'Please enter a contact number',
            email:'Please enter your email',
            thing:'Please enter the content',
            sub:'Submit',
        },
        same:{
            company:'Company Profile',
            sen_title:'Insurance',
        },
    }
}



//////////////////
// WEBPACK FOOTER
// ./lang/en/index.js
// module id = 8R3E
// module chunks = 1